import { Card } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import ProgramDeactivationChangeRequestApiService from '../../../../api/ProgramDeactivationChangeRequestApiService';
import ChangeRequestLayout from '../../../../components/postSecondary/ChangeRequestLayout';
import ChangeRequestAdditionalDetailsForm from '../../../../components/forms/postSecondary/ChangeRequestAdditionalDetailsForm';
import Routes from '../../../../config/Routes';
import * as GetProgramDeactivationChangeRequestHandler from '../../../../handlerModels/GetProgramDeactivationChangeRequestHandler';
import ChangeRequestDTO from '../../../../models/ChangeRequestDTO';
import UserSecurity from '../../../../models/UserSecurity';
import BaseFormState from '../../../../redux/bases/BaseFormState';
import { StateStoreModel } from '../../../../redux/state/StateStoreModel';
import Guid from '../../../../utils/Guid';
import HistoryUtil from '../../../../utils/HistoryUtil';
import ParameterUtil from '../../../../utils/ParameterUtil';

interface ProgramDeactivationChangeRequestStep2PageState extends BaseFormState {
  changeRequestId: string;
  changeRequest: ChangeRequestDTO;
}

interface ProgramDeactivationChangeRequestStep2PageProps {
  currentUser: UserSecurity | null;
}

class ProgramDeactivationChangeRequestStep2Page extends React.Component<ProgramDeactivationChangeRequestStep2PageProps & RouteComponentProps<RouteObject>, ProgramDeactivationChangeRequestStep2PageState> {
  constructor(props: ProgramDeactivationChangeRequestStep2PageProps & RouteComponentProps<RouteObject>) {
    super(props);

    this.state = {
      changeRequestId: Guid.Empty(),
      changeRequest: ChangeRequestDTO.create(),
    };
  }

  componentDidMount() {
    const id = ParameterUtil.getPathPart(this.props.match, 'id');
    if (id !== Guid.Empty() && this.state.changeRequestId != id) {
      this.setState({ changeRequestId: id });
      this.fetchData(id);
    }
  }

  private fetchData = (id: string) => {
    this.setState({ loading: true });

    const loaders = [];

    if (id !== Guid.Empty()) {
      loaders.push(this.loadChangeRequest(id));
    }

    Promise.all(loaders).then(() => {
      this.setState({ loading: false });
    });
  }

  private loadChangeRequest = (id: string) => {
    const request = GetProgramDeactivationChangeRequestHandler.Request.create({
      changeRequestId: id
    });

    return ProgramDeactivationChangeRequestApiService.get(request)
      .then((results: GetProgramDeactivationChangeRequestHandler.Result) => {
        if (results) {
          this.setState({
            changeRequest: results.changeRequest ?? ChangeRequestDTO.create(),
          });
        }
      }).catch(() => {
        this.setState({ error: true, message: 'Could not load change request.' });
      });
  }

  goToPreviousStep = () => {
    HistoryUtil.push(Routes.generate(Routes.EXISTING_PROGRAM_DEACTIVATION_CHANGE_REQUEST_ENTRY_1, { id: this.state.changeRequestId }, {}))
  }

  goToNextStep = () => {
    HistoryUtil.push(Routes.generate(Routes.EXISTING_PROGRAM_DEACTIVATION_CHANGE_REQUEST_ENTRY_REVIEW, { id: this.state.changeRequestId }, {}))
  }

  render() {
    return (
      <Content >
        <ChangeRequestLayout
          changeRequest={this.state.changeRequest ?? ChangeRequestDTO.create()}
          stepNumber={1}
          currentUser={this.props.currentUser ?? {} as UserSecurity}>
          <Card title="Additional Information" >
            <ChangeRequestAdditionalDetailsForm
              changeRequest={this.state.changeRequest}
              onPrevious={this.goToPreviousStep}
              onSubmit={this.goToNextStep}
              loading={this.state.loading} />
          </Card>
        </ChangeRequestLayout>
      </Content >
    );
  }
}

function mapStateToProps(state: StateStoreModel) {
  return {
    currentUser: state.UserSession.Value,
  };
}

export default withRouter(connect(mapStateToProps)(ProgramDeactivationChangeRequestStep2Page));